export const IssuerLogos = {
  Avant: require("@amount/frontend-styles/src/images/logo/logo-webbank.png"),
  avantcredit: require("./logo_avantcredit.png"),
  AvantCredit: require("./logo_avantcredit.png"),
  eloan: require("@amount/frontend-styles/src/images/logo/logo-eloan-small.png"),
  regions: require("@amount/frontend-styles/src/images/logo/logo-regions.svg"),
  Regions: require("@amount/frontend-styles/src/images/logo/logo-regions.svg"),
  td: require("!!file-loader!@amount/frontend-styles/src/images/partners/td/logo/logo-td-fit-loan.svg"),
  webbank: require("@amount/frontend-styles/src/images/logo/logo-webbank.png"),
  Webbank: require("@amount/frontend-styles/src/images/logo/logo-webbank.png"),
}

/**
 * @type { [x: string]: { svg?: string; 1x?: string; 2x?: string; } }
 */
export const BrandLogos = {
  bbva: {
    display_text: "BBVA",
    svg: require("!!file-loader!@amount/frontend-styles/src/images/partners/bbva/logo/logo-bbva.svg"),
  },
  eloan: {
    display_text: "Eloan/BPPR",
    display_text_link: "https://www.eloan.com/about-us",
    "1x": require("!!file-loader!@amount/frontend-styles/src/images/logo/logo-eloan-small.png"),
    "2x": require("!!file-loader!@amount/frontend-styles/src/images/logo/logo-eloan-large.png"),
  },
  "en-GB": {
    svg: require("!!file-loader!@amount/frontend-styles/src/images/logo/logo-avantcredit.svg"),
  },
  "en-US": {
    svg: require("!!file-loader!@amount/frontend-styles/src/images/logo/logo-avant.svg"),
  },
  hsbc: {
    display_text: "HSBC",
    svg: require("!!file-loader!@amount/frontend-styles/src/images/partners/hsbc/logo/logo-hsbc.svg"),
  },
  pnc: {
    display_text: "PNC",
    svg: require("!!file-loader!@amount/frontend-styles/src/images/partners/pnc/logo/logo-pnc.svg"),
  },
  regions: {
    display_text: "Regions",
    svg: require("!!file-loader!@amount/frontend-styles/src/images/partners/regions/logo/logo-regions.svg"),
  },
  td: {
    display_text: "TD Bank",
    primaryLogo: require("!!file-loader!@amount/frontend-styles/src/images/partners/td/logo/logo-td-bank.svg"),
    secondaryLogo: require("!!file-loader!@amount/frontend-styles/src/images/partners/td/logo/logo-td-shield.svg"),
    svg: require("!!file-loader!@amount/frontend-styles/src/images/partners/td/logo/logo-td-fit-loan.svg"),
  },
}
